module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-group', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.action,
      "data": _vm.data,
      "show-file-list": false,
      "accept": _vm.accept_types,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-success"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), (!_vm.uploaded) ? _c('b-img', {
    ref: "img",
    staticClass: "avatar mt-1",
    attrs: {
      "src": _vm.fileObj
    },
    on: {
      "error": _vm.setDefaultImg
    }
  }) : _c('b-img', {
    staticClass: "avatar mt-1",
    attrs: {
      "src": _vm.imgUrl
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-681ec4f2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUpload.vue
// module id = LdTP
// module chunks = 4